export const MARKETING_DOWNLOAD_KEY = 'marketing.download';
export const UNIQUE_DOWNLOADS_KEY = '__uniqueDownloadUrls';
